const STRINGS = {
  NA: "N/A",
};

export default STRINGS;
